import { render, staticRenderFns } from "./AnnuityTargetCustomTable.vue?vue&type=template&id=2c068588&scoped=true"
import script from "./AnnuityTargetCustomTable.vue?vue&type=script&lang=js"
export * from "./AnnuityTargetCustomTable.vue?vue&type=script&lang=js"
import style0 from "./AnnuityTargetCustomTable.vue?vue&type=style&index=0&id=2c068588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c068588",
  null
  
)

export default component.exports